module.exports = __webpack_public_path__ + "img/bench_246.25bbb1ce.jpg";